import React from "react";
import {FactoryGameType, Recipe as RecipeType} from "../types";
import {IOSummary} from "./IOSummary";
import {ItemThroughput} from "./ItemStack";
import ItemImage from "./ItemImage";
import "./Recipe.sass";
import "./Shared.sass";

type Props = {
    gameType: FactoryGameType,
    recipe: RecipeType,
}

export default function Recipe({ gameType, recipe }: Props) {
    return <div>
        <div className="itemWithName recipeHeader">
            {recipe.products[0] && <ItemImage item={recipe.products[0].item} gameType={gameType} />}
            <b>{recipe.recipeType}</b>
        </div>
        <IOSummary
            StackRender={(props) => <ItemThroughput {...props} amount={props.amount / recipe.duration * 60} />}
            gameType={gameType}
            ingredients={recipe.ingredients}
            products={recipe.products}
        />
    </div>
}
